import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createMeta, createRowActions } from "@msuite/ui/table";
import { ScopeTag } from "@msuite/ui/tag";
import { createdAtFormatter } from "@msuite/utils/date";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<any>();

export const columns = [
	columnHelper.accessor("name", {
		id: "name",
		header: localized("general.name"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor(createdAtFormatter, {
		id: "createdAt",
		header: localized("general_fields.created_at"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("scope", {
		id: "scope",
		header: localized("general.scope"),
		cell: (cell) => <ScopeTag scope={cell.getValue()} />,
	}),
	columnHelper.accessor("numberOfArticles", {
		id: "numberOfArticles",
		header: localized("stock.number_of_articles"),
		cell: (cell) => cell.getValue(),
		meta: createMeta({
			isNumeric: true,
		}),
	}),
	createRowActions(RowActions),
];
